import type { RefObject } from 'react';
import type { ImageRef } from '../../atoms/image/Image.data';

interface HorizontalCreativityRefs {
  elementRef?: RefObject<HTMLElement | null>;
  title1Ref?: RefObject<HTMLHeadingElement | null>;
  title2Ref?: RefObject<HTMLHeadingElement | null>;
  titleOutline1Ref?: RefObject<HTMLHeadingElement | null>;
  titleOutline2Ref?: RefObject<HTMLHeadingElement | null>;
  imageRef?: RefObject<ImageRef | null>;
  shapeRef?: RefObject<HTMLDivElement | null>;
  containerRef?: RefObject<HTMLElement | null>;
}

function getCenteredTravelDistance(element: HTMLElement): number {
  return (window.innerWidth + element.getBoundingClientRect().width) / 2;
}

export function setupTitleTimeline(
  timeline: gsap.core.Timeline,
  {
    title1Ref,
    title2Ref,
    titleOutline1Ref,
    titleOutline2Ref,
    shapeRef,
    imageRef,
    containerRef,
  }: HorizontalCreativityRefs,
): void {
  if (title1Ref?.current && titleOutline1Ref?.current) {
    const title1TravelDistance = () => getCenteredTravelDistance(title1Ref.current!);

    timeline.fromTo(
      [title1Ref.current, titleOutline1Ref?.current],
      { x: title1TravelDistance },
      {
        x: () => -title1TravelDistance() * 1.01,
        ease: 'Power1.easeInOut',
        duration: 1,
      },
      '<',
    );
  }

  if (title2Ref?.current && titleOutline2Ref?.current) {
    const title2TravelDistance = () => getCenteredTravelDistance(title2Ref.current!);

    timeline.fromTo(
      [title2Ref?.current, titleOutline2Ref?.current],
      { x: () => -title2TravelDistance() },
      {
        x: title2TravelDistance,
        ease: 'Power1.easeInOut',
        duration: 1,
      },
      '<',
    );
  }

  if (shapeRef?.current) {
    timeline.fromTo(
      shapeRef.current,
      {
        clipPath: 'inset(0% 0% 0% 0% round 4px)',
        webkitClipPath: 'inset(0% 0% 0% 0% round 4px)',
      },
      {
        clipPath:
          'inset(calc(50% - min(25vw, 25vh)) calc(50% - min(25vw, 25vh)) calc(50% - min(25vw, 25vh)) calc(50% - min(25vw, 25vh)) round min(25vw, 25vh))',
        webkitClipPath:
          'inset(calc(50% - min(25vw, 25vh)) calc(50% - min(25vw, 25vh)) calc(50% - min(25vw, 25vh)) calc(50% - min(25vw, 25vh)) round min(25vw, 25vh))',
        duration: 0.3,
        ease: 'Power1.easeInOut',
      },
      '<',
    );
  }

  if (imageRef?.current) {
    timeline.fromTo(
      imageRef.current,
      { scale: 1.5 },
      {
        scale: 0.6,
        // clearProps: 'scale',
        ease: 'Quad.easeInOut',
        duration: 0.4,
      },
      '<25%',
    );
  }

  if (containerRef?.current) {
    timeline.fromTo(
      containerRef.current,
      { height: '80svh', top: '10svh' },
      {
        height: '90svh',
        top: '5svh',
        duration: 0.4,
      },
      '<',
    );
  }
}
